import { ViewFilterPage } from '@/pages/buyer/ViewFilterPage';
import { DesktopViewFilterPage } from '@/pages/desktop/DesktopViewFilterPage';
import { BottomNavigation } from '@/components/common/BottomNavigation';

export function ResponsiveViewFilterPage() {
  return (
    <>
      {/* Mobile version */}
      <div className="lg:hidden">
        <div className="mobile-container bg-white min-h-screen relative">
          <ViewFilterPage />
          <BottomNavigation activeId="filter" />
        </div>
      </div>
      
      {/* Desktop version */}
      <div className="hidden lg:block">
        <DesktopViewFilterPage />
      </div>
    </>
  );
}